import { Component, ViewEncapsulation } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AppHeaderComponent } from '@portal-status/app/components/app-header/app-header.component';

@Component({
  selector: 'mc-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [AppHeaderComponent, RouterOutlet]
})
export class AppComponent { }
